import { useApiData } from "@/contexts/ApiData";
import { useEffect, useState } from "react";
import { Comment as CommentType } from "../../types";
import CommentForm from "../Forms/CommentForm";
import { useDateFormatter, useTranslations } from "@/contexts/Translation";
import Comment from "./Comment";
import { fixNewlines } from "@/lib/text";
import styles from "./List.module.css";
import { coachImages, coachLabel } from "./coach";

type ComponentProps = {
  goalId?: string;
  orgGoalId?: string;
  surveyId?: string;
  enableAiComment?: boolean;
};

const Comments = ({ goalId, surveyId, orgGoalId, enableAiComment }: ComponentProps) => {
  const d = useDateFormatter();
  const t = useTranslations("surveys");
  const [comments, setComments] = useState<CommentType[]>([]);
  const { get } = useApiData();

  useEffect(() => {
    const getComments = async () => {
      const url = orgGoalId ? `/comment/orggoal/${orgGoalId}` : goalId ? `/comment/goal/${goalId}` : `/comment/survey/${surveyId}`;
      const comments = await get(url);
      if (comments) {
        setComments(comments);
      }
    };
    getComments();
  }, [get, goalId, orgGoalId, surveyId]);

  // Functional update, so the two coach messages of one round do not overwrite each other.
  const addComment = (newComment: CommentType) => {
    setComments((prev) => [...prev, newComment]);
  };

  return (
    <div className={styles.container}>
      {comments.map((c) => (
        <Comment key={c.id}>
          <p className={styles.content}>{fixNewlines(c.content)}</p>
          <p className={styles.meta}>
            {c.isAiComment && coachImages(c).map((src) => <img key={src} title={c.emotion} className={styles.aiImage} src={src} alt='' />)}
            {c.isAiComment ? coachLabel(c, t) : c.name} {c.registered ? d(c.registered, true) : ""}
          </p>
        </Comment>
      ))}
      <CommentForm addComment={addComment} goalId={goalId} surveyId={surveyId} orgGoalId={orgGoalId} enableAiComment={enableAiComment} />
    </div>
  );
};

export default Comments;
